import * as XLSX from 'xlsx';
import { Subject, takeUntil } from 'rxjs';
import { Component, OnInit, OnDestroy, DoCheck, Input, ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
declare let $: any;
@Component({
    selector: 'car-area',
    templateUrl: './car-area.component.html'
})
export class CarAreaComponent implements OnInit, OnDestroy, DoCheck {
    Id: number = 0;
    pastArea: any[] = [];
    geoFenceUsgae: any;
    GeoFenceData: any;
    saveGeoFence: FormGroup = this.formBuilder.group({
        strSession: new FormControl(`${this.gurdService.decrypt(localStorage.getItem('Session')!)}`),
        iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
        strUnitID: new FormControl(this.Id),
        iGeoFence: new FormControl(-1),
        tiGeoFenceUsgae: new FormControl(-1),
        strSTime: new FormControl("00:00"),
        strETime: new FormControl("23:59"),
        bSendSMS: new FormControl(false),
        bSendPush: new FormControl(false),
    });
    constructor(private el: ElementRef, private notifyService: NotificationService, private router: Router, private otherService: OtherService, private _location: Location, private route: ActivatedRoute, private formBuilder: FormBuilder, private gurdService: GurdServiceService) { }
    ngOnInit(): void {
        this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
            this.Id = params['id'];
            this.getPastArea();
            this.GeoFenceUsgae();
            this.getArea();
            this.saveGeoFence.controls["strUnitID"].setValue(this.Id);
        });
    }
    goBack() {
        this._location.back();
    }
    getPastArea = async () => {
        if (this.destroyed)
            return;
        if (this.listLoading)
            return;
        this.listLoading = true;
        this.hasError = false;
        this.errorMessage = '';
        try {
            var model = {
                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                strUnitID: this.Id,
            };
            const resp = await this.post(`Radyab_GetMobileGeoFence`, model);
            this.pastArea = this.requireRows(resp.data);
        }
        catch (error) {
            if (!this.destroyed) {
                this.hasError = true;
                this.errorMessage = error instanceof Error ? error.message : 'دریافت اطلاعات ناموفق بود';
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
        finally {
            this.listLoading = false;
        }
    };
    SaveMobileGeoFence = async () => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            var model = this.saveGeoFence.value;
            var Stime = document.getElementById("Stime") as any;
            model.strSTime = Stime.value;
            var Etime = document.getElementById("Etime") as any;
            model.strETime = Etime.value;
            if (model.iGeoFence == -1) {
                this.notifyService.showError("لطفا نام محدوده را وارد کنید");
                return;
            }
            if (model.tiGeoFenceUsgae == -1) {
                this.notifyService.showError("لطفا کاربری  را وارد کنید");
                return;
            }
            const resp = await this.post(`Radyab_SaveMobileGeoFence`, model);
            let resParse = this.parse(resp.data);
            if (resParse.iResult == 0) {
                this.notifyService.showError(resParse.strError);
                return;
            }
            if (resParse.ISSessionExpired == true) {
                this.notifyService.showError('لطفا وارد سیستم شوید');
                this.otherService.removeLocalStorage();
                // this.router.navigate(['login']);
                this.router.navigate(['login'], { queryParams: { error: '10' } });
                return;
            }
            else {
                this.notifyService.showSuccess("با موفقیت ثبت شد");
                $('#carAreaModal').modal('hide');
                this.getPastArea();
                this.saveGeoFence.reset({
                    strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                    strUnitID: this.Id,
                    iGeoFence: -1,
                    tiGeoFenceUsgae: -1,
                    strSTime: "00:00",
                    strETime: "23:59",
                    bSendSMS: false,
                    bSendPush: false,
                });
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    deleteArea = async (id: any) => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            $.confirm({
                title: `آیا از حذف این محدوده اطمینان دارید ؟`,
                content: '',
                type: 'red',
                buttons: {
                    ok: {
                        text: "حذف",
                        btnClass: 'btn-success',
                        keys: ['enter'],
                        action: async () => {
                            if (this.destroyed)
                                return;
                            if (this.loading)
                                return;
                            try {
                                var model = {
                                    strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                                    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                                    iMobileGeoFences: id,
                                };
                                const resp = await this.post(`Radyab_DeleteMobileGeoFence`, model);
                                let resParse = this.parse(resp.data);
                                if (resParse.iResult == 0) {
                                    this.notifyService.showError(resParse.strError);
                                    return;
                                }
                                if (resParse.ISSessionExpired == true) {
                                    this.notifyService.showError('لطفا وارد سیستم شوید');
                                    this.otherService.removeLocalStorage();
                                    // this.router.navigate(['login']);
                                    this.router.navigate(['login'], { queryParams: { error: '11' } });
                                    return;
                                }
                                else {
                                    this.notifyService.showSuccess("با موفقیت حذف شد");
                                    this.pastArea = this.pastArea.filter((el: any) => {
                                        return el.iMobileGeoFences != id;
                                    });
                                }
                                return;
                            }
                            catch (error) {
                                if (!this.destroyed) {
                                    this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
                                }
                            }
                        }
                    },
                    cancel: {
                        text: "لغو",
                    }
                }
            });
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    GeoFenceUsgae = async () => {
        if (this.destroyed)
            return;
        try {
            const resp = await this.post(`Radyab_GetGeoFenceUsgae`, {});
            this.geoFenceUsgae = this.requireRows(resp.data);
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    getArea = async () => {
        if (this.destroyed)
            return;
        try {
            var model = {
                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
            };
            const resp = await this.post(`Radyab_GeoFence`, model);
            this.GeoFenceData = this.requireRows(resp.data);
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    private readonly destroy$ = new Subject<void>();
    private destroyed = false;
    private pendingRequests = 0;
    private listLoading = false;
    hasError = false;
    errorMessage = '';
    get loading(): boolean { return this.pendingRequests > 0 || this.listLoading; }
    get tableLoading(): boolean { return this.listLoading; }
    openArea(): void { if (!this.loading)
        $('#carAreaModal').modal('show'); }
    async onRecordAction(key: string, row: Record<string, unknown>): Promise<void> {
        if (this.loading || this.destroyed)
            return;
        if (key === 'delete')
            await this.deleteArea(row['iMobileGeoFences']);
    }

    searchText = '';
    currentPage = 1;
    pageSize = 20;
    readonly pageSizeOptions = [10, 20, 50];
    filteredRows: Record<string, unknown>[] = [];
    pagedRows: Record<string, unknown>[] = [];

    private tableSnapshot: unknown[] = [];
    private tableIdentity = '';
    readonly tableTitle = 'محدوده‌های خودرو';
    get printId(): string { return `car-area-print-${this.Id}`; }
    get hasActiveFilters(): boolean { return !!this.searchText.trim(); }
    get emptyTitle(): string {
        return this.hasActiveFilters ? 'با این فیلترها نتیجه‌ای پیدا نشد!' : 'اطلاعاتی برای نمایش وجود ندارد';
    }

    ngDoCheck(): void {
        const identity = `${this.Id}`;
        const rows = this.pastArea;
        const identityChanged = identity !== this.tableIdentity;
        if (identityChanged) this.searchText = '';
        if (identityChanged || rows.length !== this.tableSnapshot.length || rows.some((row, index) => row !== this.tableSnapshot[index])) {
            this.tableIdentity = identity;
            this.refreshTable(true);
        }
    }

    onSearchChange(): void {
        if (!this.loading) this.refreshTable(true);
    }

    clearSearch(): void {
        if (this.loading) return;
        this.searchText = '';
        this.refreshTable(true);
    }

    onPageChange(page: number): void {
        if (this.loading) return;
        this.currentPage = page;
        this.refreshTable();
    }

    onPageSizeChange(size: number): void {
        if (this.loading || !this.pageSizeOptions.includes(size)) return;
        this.pageSize = size;
        this.refreshTable(true);
    }

    numberValue(value: unknown): number {
        const number = Number(value);
        return Number.isFinite(number) ? number : 0;
    }

    private normalizeSearch(value: unknown): string {
        return String(value ?? '').replace(/[۰-۹]/g, digit => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
            .replace(/[٠-٩]/g, digit => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit))).trim().toLowerCase();
    }

    private refreshTable(resetPage = false): void {
        const rows = this.pastArea;
        this.tableSnapshot = [...rows];
        const fields = ["strTitle","strGeoFenceUsgae_strComment"];
        const query = this.normalizeSearch(this.searchText);
        this.filteredRows = query
            ? rows.filter(row => this.normalizeSearch(fields.map(field => row[field]).join(' ')).includes(query))
            : [...rows];
        this.currentPage = resetPage ? 1 : Math.max(1, Math.min(this.currentPage, Math.ceil(this.filteredRows.length / this.pageSize) || 1));
        this.pagedRows = this.filteredRows.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);

    }

    exportExcel(): void {
        if (this.loading || this.hasError || !this.filteredRows.length) return;
        const headers = ["#","نام محدوده","نوع کاربری"];
        const rows: (string | number)[][] = this.filteredRows.map((row, index) =>
            [index + 1, String(row['strTitle'] ?? ''), String(row['strGeoFenceUsgae_strComment'] ?? '')]);
        rows.push([`تعداد کل: ${this.filteredRows.length}`, '', '']);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet([headers, ...rows]), 'Sheet1');
        XLSX.writeFile(workbook, `${this.tableTitle}.xlsx`);
    }

    private parse(data: unknown): ReturnType<typeof JSON.parse> {
        return typeof data === 'string' ? JSON.parse(data) : data;
    }
    private requireRows(data: unknown): Record<string, unknown>[] {
        const parsed = this.parse(data);
        if (!Array.isArray(parsed))
            throw new Error(parsed?.strError || 'پاسخ سرور نامعتبر است');
        return parsed;
    }
    private async post(url: string, payload?: unknown) {
        if (this.destroyed)
            throw new Error('درخواست لغو شد');
        this.pendingRequests++;
        try {
            const response = await axios.post(url, payload);
            if (this.destroyed)
                throw new Error('درخواست لغو شد');
            const parsed = this.parse(response.data);
            if (parsed === -100 || parsed?.ISSessionExpired || parsed?.ISessionExpired) {
                this.otherService.removeLocalStorage();
                void this.router.navigate(['login']);
                throw new Error('لطفا وارد سیستم شوید');
            }
            return response;
        }
        finally {
            this.pendingRequests--;
        }
    }
    ngOnDestroy(): void {
        this.destroyed = true;
        this.destroy$.next();
        this.destroy$.complete();
        $(this.el.nativeElement).find('.modal').off('.vehicleRecords').modal('hide');
    }
}
